export const Input = ({ label, placeholder, className = '', ...props }) => {
  return (
    <>
      {label && (
        <label htmlFor="role" className="form-label">
          {label}
        </label>
      )}
      <input
        type="text"
        className={`form-control ${className}`}
        placeholder={placeholder}
        {...props}
      />
    </>
  );
};
